import "core-js/modules/es.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SvcDiscountBase from './svcDiscountBase';
import SvcDiscountGroupBase from './svcDiscountGroupBase';
import SvcDiscountInterval from './svcDiscountInterval';
import SvcDiscountActivity from './svcDiscountActivity';
export default {
  name: 'SvcDiscount',
  components: {
    SvcDiscountBase: SvcDiscountBase,
    SvcDiscountGroupBase: SvcDiscountGroupBase,
    SvcDiscountInterval: SvcDiscountInterval,
    SvcDiscountActivity: SvcDiscountActivity
  },
  data: function data() {
    return {
      activeName: 'SvcDiscountBase'
    };
  },
  methods: {
    handleClick: function handleClick(tab, event) {
      this.activeName = tab.name;
    }
  }
};